export default {
  id: {
    dbKey: 'id',
    type: 'string',
    displayName: 'ID',
  },
  name: {
    dbKey: 'name',
    type: 'string',
    displayName: 'Version',
  },
  mock: {
    id: '',
    name: '',
  },
};
